const setItem = (key, value)=>{
    if(localStorage && localStorage.setItem){
        localStorage.setItem(key, value);
    }
}

const getItem = (key)=>{
    if(localStorage && localStorage.getItem){
        return localStorage.getItem(key);
    }
}


module.exports = { setItem, getItem }


// WEBPACK FOOTER //
// src/service/localStorageService.js